<div class="bg-transparent d-flex flex-column justify-content-center inline-alerts">
  @for (alert of inlineAlerts(); track alert?.id ?? alert) {
    <mbs-alert
      class="content-center mb-1"
      [alertRef]="alert"
      [autoClose]="alert.autoClose"
      [class.mb-1]="!$last"
      [closable]="true"
      [content]="alert.content"
      [context]="alert.context"
      [icon]="true"
      [id]="alert.id"
      [ignoreRouteChanges]="alert.ignoreRouteChanges"
      [type]="alert.type"
      (close)="removeAlert($event)" />
  }
</div>
<div class="d-flex flex-row justify-content-center overlay-alerts">
  <div class="position-fixed text-center">
    @for (alert of overlayAlerts(); track alert?.id ?? alert) {
      <div>
        <mbs-alert
          class="d-inline-flex text-start"
          [alertRef]="alert"
          [autoClose]="alert.autoClose"
          [class.mb-0]="$last"
          [closable]="true"
          [content]="alert.content"
          [context]="alert.context"
          [icon]="true"
          [id]="alert.id"
          [ignoreRouteChanges]="alert.ignoreRouteChanges"
          [type]="alert.type"
          (close)="removeAlert($event)" />
      </div>
    }
  </div>
</div>
